/**
 * Display the sticky planbox when scrolling over the feature table.
 *
 * @package Qustodio\Theme
 */
import scroll from '../../../helpers/scroll';
import header from '../../../template-parts/header';
import containers from './sticky-planbox-container';

const featureTable = (tableElement) => {
  let planboxContainerElement;
  let planboxElementDesktop;
  let planboxElementMobile;
  let offsetTop = 0;
  let displayStickyPlanbox = false;

  const calcOffsetTop = () => {
    const tableTopBorder = tableElement.getBoundingClientRect().top;
    return tableTopBorder + scroll.getCurrentPosition() - header.getHeight();
  };

  const shouldDisplayStickyPlanbox = () => scroll.getCurrentPosition() >= offsetTop;

  const movePlanboxToHeader = () => {
    planboxElementDesktop = containers.getContainerDesktop().appendChild(planboxElementDesktop);
    planboxElementMobile = containers.getContainerMobile().appendChild(planboxElementMobile);
  };

  const putPlanboxBackInTable = () => {
    planboxElementDesktop = planboxContainerElement.appendChild(planboxElementDesktop);
    planboxElementMobile = planboxContainerElement.appendChild(planboxElementMobile);
  };

  const maybeMakePlanBoxSticky = () => {
    const wasDisplayingStickyPlanbox = displayStickyPlanbox;

    if (shouldDisplayStickyPlanbox()) {
      if (wasDisplayingStickyPlanbox === false) {
        displayStickyPlanbox = true;
        movePlanboxToHeader();
      }
    } else if (wasDisplayingStickyPlanbox === true) {
      displayStickyPlanbox = false;
      putPlanboxBackInTable();
    }
  };

  const init = () => {
    planboxContainerElement = tableElement.querySelector('.js-sticky-planboxes__table-container');
    planboxElementDesktop = planboxContainerElement.querySelector('.js-sticky-planboxes__planboxes--desktop');
    planboxElementMobile = planboxContainerElement.querySelector('.js-sticky-planboxes__planboxes--mobile');
    offsetTop = calcOffsetTop();
    maybeMakePlanBoxSticky();
  };

  const onResize = () => {
    offsetTop = calcOffsetTop();
    maybeMakePlanBoxSticky();
  };

  const onScroll = () => {
    maybeMakePlanBoxSticky();
  };

  return {
    init,
    onResize,
    onScroll,
  };
};

export default featureTable;
